import * as React from 'react';
import { TooltipDesktop } from '@cian/ui-kit';
import { WorkHonestlyTooltip } from '../WorkHonestlyTooltip';
import { EHonestWorkIconSize } from '../UserWorkHonestlyIcon/constants';
import { UserWorkHonestlyIcon } from '../UserWorkHonestlyIcon';

export interface IUserWorkHonestlyProps {
  levelNumber?: number | null;
  levelName?: string | null;
  size?: EHonestWorkIconSize;
}

export const UserWorkHonestlyInfo = ({ levelNumber, levelName, size }: IUserWorkHonestlyProps) => {
  if (!levelName || !levelNumber || levelNumber < 3) {
    return null;
  }

  return (
    <TooltipDesktop
      title={<WorkHonestlyTooltip levelNumber={levelNumber} levelName={levelName} />}
      theme="white"
      placement="right-start"
    >
      <span>
        <UserWorkHonestlyIcon levelNumber={levelNumber} size={size} />
      </span>
    </TooltipDesktop>
  );
};
